import { ISuggestedGroupName } from '@network/models/suggested-group-name.model'
import { IPayload } from '@network/models/global.model'
import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'

export class SuggestedGroupNameApi {
  constructor(private axios: AxiosService) {}

  getSuggestedGroupNames = async () => {
    const response = await this.axios.get<IPayload<ISuggestedGroupName[]>>(
      Endpoints.getSuggestedGroupNames,
    )
    return response
  }

  getSuggestedGroupName = async (id: number) => {
    const response = await this.axios.get<IPayload<ISuggestedGroupName>>(
      Endpoints.getSuggestedGroupName(id),
    )
    return response
  }
}
